import StockOpnamesApiV2 from 'api/v2/admins/stock-opnames-api-v2'
import RedirectButton from 'components/atoms/redirect-button'
import TitlePage from 'components/atoms/title-page'
import { ALERT_TYPES } from 'constants/alert-constants'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useHistory } from 'react-router'
import { Button, Card, CardBody, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const INTERNAL_CATEGORY_OPTIONS = [
  { key: 'H', label: 'H - Hermes' },
  { key: 'W', label: 'W - Watch' },
  { key: 'C', label: 'C - Curated' }
]

const StockOpnameCreatePage = ({ pageUtils }) => {
  const history = useHistory()
  const [ title, setTitle ] = useState('')
  const [ targetDate, setTargetDate ] = useState('')
  const [ internalCategoryFilters, setInternalCategoryFilters ] = useState([ 'H', 'W', 'C' ])
  const [ autoGenerateEntries, setAutoGenerateEntries ] = useState(true)
  const [ inProgress, setInProgress ] = useState(true)
  const [ isSubmitting, setIsSubmitting ] = useState(false)

  const handleToggleInternalCategory = (key) => {
    setInternalCategoryFilters((prev) => {
      if (prev.includes(key)) {
        const next = prev.filter((item) => item !== key)
        return next.length ? next : prev
      }

      return [ ...prev, key ]
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setIsSubmitting(true)

    await StockOpnamesApiV2.create({
      title,
      target_date              : targetDate || null,
      internal_category_filter : internalCategoryFilters.join(','),
      auto_generate_entries    : autoGenerateEntries,
      in_progress              : inProgress
    })
      .then((response) => {
        const stockOpname = response?.data?.stock_opname
        const generationResult = response?.data?.generation_result
        const createdCount = generationResult?.created_count
        const message = createdCount !== undefined
          ? `Stock Opname has been created. ${createdCount} IQ entries generated.`
          : 'Stock Opname has been created.'

        pageUtils?.setAlertMsg?.(message, ALERT_TYPES.SUCCESS)
        history.push(`/app/stock-opnames/${stockOpname.id}`)
      })
      .catch((error) => {
        pageUtils?.setApiErrorMsg?.(error?.response?.data)
        pageUtils?.setAlertMsg?.(error?.response?.data?.messages?.base || 'Unable to create stock opname', ALERT_TYPES.DANGER)
      })
      .finally(() => setIsSubmitting(false))
  }

  return (
    <>
      <TitlePage mainTitle={ 'Stock Opname' } subTitle={ 'New' } />

      <RedirectButton
        color='secondary'
        text='Back to Stock Opname List'
        path='/app/stock-opnames/list-page'
        className='mb-3'
      />

      <Card>
        <CardBody>
          <Form onSubmit={ handleSubmit }>
            <FormGroup>
              <Label>{ 'Title' }</Label>
              <Input
                value={ title }
                onChange={ (event) => setTitle(event.target.value) }
                placeholder='Contoh: STO 150626 HWC'
              />
            </FormGroup>

            <Row>
              <Col md={ 4 }>
                <FormGroup>
                  <Label>{ 'Generate stock sampai tanggal' }</Label>
                  <Input
                    type='date'
                    value={ targetDate }
                    onChange={ (event) => setTargetDate(event.target.value) }
                  />
                  <small className='text-muted'>
                    { 'Kosongkan kalau mau ambil semua stok fisik di toko (IQ > 0), termasuk SQ > 0 dan Stored Only (SQ = 0).' }
                  </small>
                </FormGroup>
              </Col>
              <Col md={ 8 }>
                <Label>{ 'Filter Internal Category' }</Label>
                <Row>
                  {
                    INTERNAL_CATEGORY_OPTIONS.map((option) => (
                      <Col md={ 4 } key={ option.key }>
                        <FormGroup check className='mb-2'>
                          <Label check>
                            <Input
                              type='checkbox'
                              checked={ internalCategoryFilters.includes(option.key) }
                              onChange={ () => handleToggleInternalCategory(option.key) }
                            />
                            { ` ${option.label}` }
                          </Label>
                        </FormGroup>
                      </Col>
                    ))
                  }
                </Row>
              </Col>
            </Row>

            <FormGroup check className='mb-3'>
              <Label check>
                <Input
                  type='checkbox'
                  checked={ autoGenerateEntries }
                  onChange={ (event) => setAutoGenerateEntries(event.target.checked) }
                />
                { ' Auto-generate entries dari stok fisik (IQ > 0)' }
              </Label>
            </FormGroup>

            <FormGroup check className='mb-3'>
              <Label check>
                <Input
                  type='checkbox'
                  checked={ inProgress }
                  onChange={ (event) => setInProgress(event.target.checked) }
                />
                { ' In Progress' }
              </Label>
            </FormGroup>

            <Button color='primary' disabled={ isSubmitting } type='submit'>
              { isSubmitting ? 'Saving...' : 'Save Stock Opname' }
            </Button>
          </Form>
        </CardBody>
      </Card>
    </>
  )
}

StockOpnameCreatePage.propTypes = propTypes

export default StockOpnameCreatePage
